import PropTypes from 'prop-types';
import { useOpenClose } from '@evertrue/et-components';
import ActionMenu2 from 'components/controls/action-menu2';
import ActionMenuItem from 'components/controls/action-menu-item';
import DisconnectDnsModal from './DisconnectDnsModal';

/**
 * "Manage DNS" dropdown for the domain configuration states. Disconnect-only
 * after the default-email field was removed from the org settings UI.
 */
const DnsManageDropdown = ({ onDisconnect, domainName, activeCadenceCount, pendingBulkMessageCount }) => {
  const [isDisconnectOpen, openDisconnectModal, closeDisconnectModal] = useOpenClose();

  return (
    <>
      <ActionMenu2 label="Manage DNS" width={180}>
        <ActionMenuItem title="Disconnect DNS" className="is-destructive" onClick={openDisconnectModal}>
          Disconnect DNS
        </ActionMenuItem>
      </ActionMenu2>
      <DisconnectDnsModal
        isOpen={isDisconnectOpen}
        closeModal={closeDisconnectModal}
        onConfirm={onDisconnect}
        domainName={domainName}
        activeCadenceCount={activeCadenceCount}
        pendingBulkMessageCount={pendingBulkMessageCount}
      />
    </>
  );
};

DnsManageDropdown.propTypes = {
  onDisconnect: PropTypes.func.isRequired,
  domainName: PropTypes.string,
  activeCadenceCount: PropTypes.number,
  pendingBulkMessageCount: PropTypes.number,
};

export default DnsManageDropdown;
